export default __webpack_public_path__ + "static/logo-merck-d37888a4e6298b514d86a08a7a13af05.svg";